'use strict';

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';
import { attemptsOperations, attemptsSelectors } from '@/state/domains/attempts';
import { assignmentsOperations, assignmentsSelectors } from '@/state/domains/assignments';
import { locationsSelectors } from '@/state/domains/locations';

import Link from '@/views/common/Link';

import s from './styles.scss';

const ToLink = ({ id, direction }) => {

	const icon = <FontAwesomeIcon
		icon={ `angle-${ direction }` }
		size='3x'
		color='#000'
	/>;

	if (id) {
		return <Link to={ id }>{ icon }</Link>;
	}

	return <span className={ s.trans }>{ icon }</span>;
};

const Main = connect(
	(state, props) => ({
		date: appSelectors.getPageDate(state, props),
		location: locationsSelectors.getPageLocation(state, props),
		pageUrl: appSelectors.getPageUrl(state, props),
		username: appSelectors.getPageUsername(state, props),
		isPageLoaded: appSelectors.isPageLoaded(state, props),
		user: usersSelectors.getPageUser(state, props),
		nextUrl: assignmentsSelectors.getNextUrl(state, props),
		prevUrl: assignmentsSelectors.getPrevUrl(state, props),
	}),
	{
		fetchUser: usersOperations.fetchUser,
		fetchUserWeeklyAttempts: attemptsOperations.fetchUserWeeklyAttempts,
		getWeekNav: appOperations.getWeekNav,
		getAssignments: assignmentsOperations.getAssignments,
		setPageLoaded: appOperations.setPageLoaded,
	}
)(
	(props) => {

		const {
			username,
			date,
			pageUrl,
			prevUrl,
			nextUrl,
			isPageLoaded,
			user,
			location,
			setModalClose,
			fetchUser,
			fetchUserWeeklyAttempts,
			setPageLoaded,
			getWeekNav,
			getAssignments,
		} = props;
		
		useEffect(
			() => {
				if (!isPageLoaded) {

					const p1 = getAssignments(username, [ date ]);

					Promise.all([ p1 ]).then(
						([ r1 ]) => {
							if (r1.success) {
								setPageLoaded(pageUrl);
							}
						}
					);
				}
			},
			[ pageUrl ]
		);

		if (!isPageLoaded) {
			return <div />;
		}

		const { streetNumber, streetName, subunit, city, state, zip } = location;

		const addressNorm = (`${ streetNumber || '' } ${ streetName || '' }`).trim();

		return (
			<div className={ s.root }>
				<div className={ s.column }>
					<div className={ s.recipientCont } >
						<div className={ s.recipient }>
							<div className={ s.locBtn }>
								<ToLink id={ prevUrl } direction='left' />
							</div>
							<div className={ s.addressColumn }>
								<div className={ s.addressRows }>
									{ addressNorm && <div className={ s.address }>{ addressNorm }</div> }
									{ subunit && <div>{ subunit }</div> }
									<div>{ !!city && `${ city }, ${ state } ${ zip }` }</div>
								</div>
							</div>
							<div className={ s.locBtn }>
								<ToLink id={ nextUrl } direction='right' />
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
);

export const components = {
	main: Main,
};

export default Main;
